module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG28fb40480630188a21cbd8883956b251.28fb4048.png";